<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/codeplaterateinfo/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
      downloadPower="/codeplaterateinfo/PeopleExport"
      :showDownloadPower="false"
      @down="down"
      showDownloadPowerType="warning"
    >
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="商户号">
        <el-input v-model="formModel.merNo" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="agentId"
        label="代理商ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merchantNo"
        label="商户号"
        :formatter="formatterTableData"
        min-width="260"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merName"
        label="商户名称"
        :formatter="formatterTableData"
        min-width="260"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sn"
        label="SN"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="oldBpName"
        label="原费率"
        :formatter="formatterTableData"
        min-width="260"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="newBpName"
        label="新费率"
        :formatter="formatterTableData"
        min-width="260"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        fixed="right"
        prop="status"
        label="状态"
        min-width="260"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{
            scope.row.status == 1
              ? "成功"
              : scope.row.status == 0
              ? "失败"
              : "--"
          }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        prop="createTime"
        label="创建时间"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import TimeRange from "service/constant/TimeRange";

import PosService from "service/PosService";
import StatisticsService from "service/StatisticsService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "codeplaterateinfo",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      formModel: {
        merNo: "",
        userId: "",
        status: "",
        time: "",
      },
      tableData: [],
      status: [
        {
          id: "",
          name: "全部",
        },
        {
          id: "0",
          name: "失败",
        },
        {
          id: "1",
          name: "成功",
        },
      ],
      submitService: PosService.codeplaterateinfoList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        merNo: this.formModel.merNo,
        userId: this.formModel.userId,
        status: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length) {
        params.createTimeStart = this.formModel.time[0];
        params.createTimeEnd = this.formModel.time[1];
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        time: "",
        status: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    down() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "exportHlfInfo",
            "8885",
            "/hlf/t-hlf-info-dtl/"
          )
        : "";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/PosImplement/CodePlateRateInfo.vue